<template>
  <div class="container-fluid">
    <div id="topo" class="card-header">
			<div class="row">
				<div class="col col-xs-2">
					<h4 class="panel-title">
						<span class="title">Consulta Emails Enviados</span>
						<br />
						<span class="navigation">Emails > Consulta</span>
					</h4>
				</div>
			</div><!--row-->
		</div><!--card-header-->

    <div class="card-body">
      <div class="row">
        <div class="col-md-3 col-lg-2 mb-3">
          <span class="p-fluid">
            <Calendar id="dataIni" name="dataIni" v-model="dataIni" :showIcon="true" dateFormat="dd/mm/yy"
              placeholder="Data Inicial" @keyup.enter="pesquisar" v-maska="'##/##/####'" />
          </span>
        </div>
        <div class="col-md-3 col-lg-2 mb-3">
          <span class="p-fluid">
            <Calendar id="dataFim" name="dataFim" v-model="dataFin" :showIcon="true" dateFormat="dd/mm/yy"
              placeholder="Data Final" @keyup.enter="pesquisar" v-maska="'##/##/####'" />
          </span>
        </div>
        <div class="col-md-6 col-lg-4 mb-7">
          <span class="p-fluid">
            <AutoComplete
              id="tipoObra"
              v-model="selectedTipoEmail"
              :dropdown="true"
              :suggestions="filteredTipoEmail"
              @complete="searchTipoEmail($event)"
              field="nome"
              placeholder="Pesquisar"
            >
              <template #item="slotProps">
                <div class="p-fluid" style="max-width: 50vw">
                  {{ slotProps.item.nome }}
                </div>
              </template>
            </AutoComplete>
          </span>
        </div>
        <div class="md-2 mb-2">
					<span class="p-fluid">
						<Button label="Pesquisar" title="Pesquisar" type="button" icon="pi pi-search" :disabled="loading"
							@click="pesquisar()" />
					</span>
        </div>
        <div class="md-2 md-2" style="margin-left: 18px;">
					<span class="p-fluid">
						<Button label="Imprimir" title="Imprimir" type="button" icon="pi pi-print" :disabled="loading"
							@click="imprimirEmailsEnviados()" />
					</span>
        </div>
      </div>
    </div>

    <div class="row">
      <DataTable :value="emailsEnviadosList" :paginator="true" :rows="10" class="p-datatable-responsive" :autoLayout="true">
        <Column field="dataFormatada" header="Data Envio"></Column>
        <Column field="numero" header="Número"></Column>
        <Column field="destinatario" header="Destinátario"></Column>
        <Column field="tipoEmail" header="Tipo Email"></Column>
      </DataTable>
    </div>
  </div><!--container-fluid-->
</template>

<script>
/* eslint-disable */
  import LoginService from "../services/acesso/login.service";
  import EmailsEnviadosService from '../services/nfse/emails.enviados.service';
  import ReportService from "../services/report.service";

  export default {
    name: 'ConsultaEmailsEnviados',
    data(){
      return{
        loading: false,
			  display: false,
        search: false,
        emailsEnviadosList: [],
        currentUser: null,
        dataIni: null,
        dataFin: null,
        selectedTipoEmail: null,
        filteredTipoEmail: null
      }
    },

    created() {
      this.currentUser = LoginService.currentUserValue;
      this.dataIni = new Date();
      this.dataIni.setDate(this.dataIni.getDate()-30);
      this.dataFin = new Date();
      this.pesquisar();
	  },

    methods:{
      pesquisar() {
        let msg = null;

        if (!this.dataIni) {
          msg = "É necessário selecionar uma data inicial";
        }

        if (!this.dataFin) {
          msg = "É necessário selecionar uma data final";
        }

        if (!msg) {
          this.search = true;
          EmailsEnviadosService.findAllEmailsEnviados(
            this.currentUser.contribuinte.idContribuinte,
            this.dataIni,
            this.dataFin,
            this.selectedTipoEmail && this.selectedTipoEmail.id
            ? this.selectedTipoEmail.id
            : ""
          ).then(
            (response) => {
              this.emailsEnviadosList = response;
            },
            error => {
              let errorMessage = "Houve um problema ao listar os Emails!";
              if (error.response) {
                errorMessage = error.response.data;
              }
              this.$toast.add({
                severity: "error",
                summary: errorMessage
              });
            }
          );
          this.search = false;
        }else{
          this.$root.$emit("alert:warn", msg);
        }
		  },
      searchTipoEmail(event){
        setTimeout(async () => {
          this.filteredTipoEmail = await EmailsEnviadosService.findTipoEmail(
            event.query
          );
        }, 550);
		  },
      imprimirEmailsEnviados() {
        var msg = null;
        if (!this.dataIni) {
          msg = "É necessário informar a data inicial!";
        } else if (!this.dataFin) {
          msg = "É necessário informar a data final!";
        }
        if (!msg) {
          this.processando(true);
          ReportService.imprimir("ConsultaEmailsEnviados", [
            {
              param: "ID_CLIENTE",
              string: this.currentUser.usuario.idCliente
            },
            {
              param: "DATA_INICIAL",
              date: this.dataIni
            },
            {
              param: "DATA_FINAL",
              date: this.dataFin
            },
            {
            param: "TIPO_EMAIL",
            string:
              this.selectedTipoEmail && this.selectedTipoEmail.id
              ? this.selectedTipoEmail.id
                : null,
            },
          ])
            .then(
              () => {},
              error => {
                this.$root.$emit("alert:warn", "Erro ao Imprimir!");
                console.log(error);
              }
            )
            .then(() => {
              this.processando(false);
            });
        } else {
          this.$root.$emit("alert:warn", msg);
        }
      },
      processando(show) {
        if (show) {
          this.loading = true;
          this.$root.$emit("loading:show");
        } else {
          this.loading = false;
          this.$root.$emit("loading:hide");
        }
      }
    }
  };
</script>
